"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregationIntervalHelperByValueTypeId = void 0;
const _aggregation_helpers_1 = require("../../_aggregation_helpers");
exports.aggregationIntervalHelperByValueTypeId = {
    grapePowderyMildewModelPredictedRisk: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
};
//# sourceMappingURL=grape_powdery_mildew.js.map